<template>
  <div class="filter-item">
    <div class="md-layout">
      <div class="md-layout-item">
        <md-field>
          <label>Поиск</label>
          <md-input v-bind:value="searchText()"
                    v-on:input="searchText($event)"  v-on:keyup.enter="searchUserChange" md-dense></md-input>
        </md-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserSearch',
  data () {
    return {
      value: null
    }
  },
  methods: {
    searchUserChange () {
      this.$emit('changeUsersFilter')
    },
    searchText (cl) {
      if (cl === '') {
        this.$store.state.filtersUsers.q = null
        return this.$store.state.filtersUsers.q
      }

      if (typeof (cl) !== 'undefined') {
        this.$store.state.filtersUsers.q = cl
      }
      return this.$store.state.filtersUsers.q
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/filters/users/UserSearch.vue